module.exports = __webpack_public_path__ + "static/media/CaptGervais.984ac15d.JPG";